<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15.7071,10.292889940395355C16.0976,10.683419940395355,16.0976,11.316599940395355,15.7071,11.707099940395356C15.7071,11.707099940395356,12.7071,14.707099940395356,12.7071,14.707099940395356C12.0771,15.337099940395355,11,14.890899940395355,11,13.999999940395355C11,13.999999940395355,11,7.999999940395355,11,7.999999940395355C11,7.109099940395355,12.0771,6.6629299403953555,12.7071,7.292889940395355C12.7071,7.292889940395355,15.7071,10.292889940395355,15.7071,10.292889940395355C15.7071,10.292889940395355,15.7071,10.292889940395355,15.7071,10.292889940395355ZM12,1.9999999403953552C12,2.2799999403953555,11.89,2.5299999403953555,11.71,2.6999999403953554C11.71,2.6999999403953554,8,6.409999940395355,8,6.409999940395355C8,6.409999940395355,8,9.999999940395355,8,9.999999940395355C8,10.279999940395355,7.89,10.529999940395355,7.71,10.709999940395356C7.71,10.709999940395356,5.71,12.709999940395356,5.71,12.709999940395356C5.53,12.889999940395356,5.28,12.999999940395355,5,12.999999940395355C4.45,12.999999940395355,4,12.549999940395356,4,11.999999940395355C4,11.999999940395355,4,6.409999940395355,4,6.409999940395355C4,6.409999940395355,0.29,2.709999940395355,0.29,2.709999940395355C0.11,2.5299999403953555,0,2.2799999403953555,0,1.9999999403953552C0,1.4499999403953552,0.45,0.9999999403953552,1,0.9999999403953552C1,0.9999999403953552,11,0.9999999403953552,11,0.9999999403953552C11.55,0.9999999403953552,12,1.4499999403953552,12,1.9999999403953552C12,1.9999999403953552,12,1.9999999403953552,12,1.9999999403953552Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'FilterOpen',
} as DefineComponent
</script>
